export default "__VITE_ASSET__D$qxiSe7__"